import * as API from "middleware/api";

export const loadSentRequestsMiddleware = (filters) =>
    API.executeWithAccessToken("debin.load.sentRequests", { ...filters, type: "vendedor" });

export const sendAddAccountsAction = (otp, idAccount, userId) =>
    API.executeWithAccessToken("debin.accounts.addOrRemove", { _otp: otp, idAccount, userId });

export const cancelDebin = (otp, debin) => {
    const {
        id,
        seller: { documentNumber },
    } = debin;
    return API.executeWithAccessToken("debin.cancel.sentRequest.send", { _otp: otp, documentNumber, id });
};

export const loadIncomingDebinListMiddleware = (filters) =>
    API.executeWithAccessToken("debin.load.sentRequests", { ...filters, type: "comprador" });

export const removeSellerAccountMiddleware = (idAccount) =>
    API.executeWithAccessToken("debin.seller.accounts.remove", { idAccount });

export const acceptIncomingDebinPreMiddleware = (idDebin) =>
    API.executeWithAccessToken("debin.incoming.accept.pre", { idDebin });

export const createCredinPre = (debin, recipients) =>
    API.executeWithAccessToken("credin.create.preview", { ...debin, recipients });

const buildCredinSendPayload = (otp, debin, recipients, id, cbuList, idTransactionToDelete) => {
    const credinData = { ...debin };
    delete credinData.idTransactionToDelete;

    return {
        _otp: otp,
        ...credinData,
        recipients,
        id,
        cbuList,
        ...(idTransactionToDelete && !credinData.idTransaction ? { idTransactionToDelete } : {}),
    };
};

export const createCredin = (otp, debin, recipients, id, cbuList, idTransactionToDelete) =>
    API.executeWithAccessToken(
        "credin.sentRequest.send",
        buildCredinSendPayload(otp, debin, recipients, id, cbuList, idTransactionToDelete),
    );

export const createCredinCVU = (otp, debin, recipients, id, cbuList, idTransactionToDelete) =>
    API.executeWithAccessToken(
        "credinCVU.sentRequest.send",
        buildCredinSendPayload(otp, debin, recipients, id, cbuList, idTransactionToDelete),
    );

export const loadSellerDebinDetail = (idDebin) => API.executeWithAccessToken("debin.seller.detail", { idDebin });

export const createDebin = (otp, debin, recipients) =>
    API.executeWithAccessToken("debin.create.send", { _otp: otp, ...debin, recipients });

export const createDebinPre = (debin, recipients) =>
    API.executeWithAccessToken("debin.create.preview", { ...debin, recipients });

export const acceptIncomingDebinCVUSendMiddleware = (
    currency,
    amount,
    idDebin,
    otp,
    idAccount,
    userId,
    debitAccount,
    sellerDetail,
    idVoucher,
) =>
    API.executeWithAccessToken("debinCVU.incoming.accept.send", {
        currency,
        amount: {
            quantity: amount,
            currency,
        },
        idDebin,
        _otp: otp,
        idAccount,
        userId,
        debitAccount,
        sellerDetail,
        idVoucher,
    });
export const acceptIncomingDebinSendMiddleware = (
    currency,
    amount,
    idDebin,
    otp,
    idAccount,
    userId,
    debitAccount,
    sellerDetail,
    idVoucher,
    isOwn,
) =>
    API.executeWithAccessToken("debin.incoming.accept.send", {
        currency,
        amount: {
            quantity: amount,
            currency,
        },
        idDebin,
        _otp: otp,
        idAccount,
        userId,
        debitAccount,
        sellerDetail,
        idVoucher,
        isOwn,
    });

export const declineIncomingDebinSendMiddleware = (currency, amount, idDebin, otp, idAccount, userId) =>
    API.executeWithAccessToken("debin.incoming.decline.send", {
        currency,
        amount,
        idDebin,
        _otp: otp,
        idAccount,
        userId,
    });

export const chargebackIncomingDebinSendMiddleware = (
    currency,
    amount,
    idDebin,
    buyerCuit,
    buyerCbu,
    sellerCuit,
    sellerCbu,
    otp,
) =>
    API.executeWithAccessToken("chargeback.recurrency", {
        currency,
        amount,
        idDebin,
        buyerCuit,
        buyerCbu,
        sellerCuit,
        sellerCbu,
        _otp: otp,
    });

export const chargebackPullIncomingDebinSendMiddleware = (currency, amount, idDebin, reason, debinDetail) =>
    API.executeWithAccessToken("chargeback.pull", {
        currency,
        amount,
        idDebin,
        reason,
        debinDetail,
    });

export const exportIncomingDebinTicket = (
    creationDate,
    idVoucher,
    debitAccount,
    sellerAccount,
    sellerCbu,
    sellerDocumentType,
    sellerDocumentNumber,
    sellerTitle,
    sellerBank,
    reference,
    amountCurrency,
    amountQuantity,
    concept,
    expirationDate,
    description,
    idDebin,
) =>
    API.executeWithAccessToken("/export.incoming.debin.ticket", {
        creationDate,
        idVoucher,
        debitAccount,
        sellerAccount,
        sellerCbu,
        sellerDocumentType,
        sellerDocumentNumber,
        sellerTitle,
        sellerBank,
        reference,
        amountCurrency,
        amountQuantity,
        concept,
        expirationDate,
        description,
        idDebin,
    });

export const exportTermsAndConditions = (format, dummy) =>
    API.executeAnonymous("/session.exportTermsAndConditions", { format, dummy });

export const getSeller = (seller) => API.executeWithAccessToken("/get.debin.seller", { seller });

export const relateBuyerToRecurrency = (debinPrestacion) =>
    API.executeWithAccessToken("/load.debin.recurrency", { ...debinPrestacion });

export const getRecurrencies = (form) => API.executeWithAccessToken("/debin.recurrency.list", { ...form });

export const getProgrammedRecurrencies = (form) =>
    API.executeWithAccessToken("/debin.recurrency.programmed.list", { ...form });

export const getDebinRecurrencyDetail = (id) => API.executeWithAccessToken("/debin.recurrency.detail", { id });

export const setUpdateRecurrencyState = (debin) =>
    API.executeWithAccessToken("/change.status.debin.recurrency", { ...debin });

export const listConcepts = () => API.executeWithAccessToken("/debin.create.pre");
